import { createSlice } from "@reduxjs/toolkit";

import {
    getAllLeadServiceAsync,
    getLeadTemlateName,
} from "./leadService.asyncActions";

const initialState = {
    getAllLeadService: {
        message: "",
        status: "idle",
        leadService: [],
    },
    leadTemplateNameState: {
        message: "",
        status: "idle",
        templateNames: {},
    },
};

export const leadServiceSlice = createSlice({
    name: "getAllLeadServiceState",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllLeadServiceAsync.pending, (state) => {
                state.getAllLeadService.status = "loading";
            })
            .addCase(getAllLeadServiceAsync.fulfilled, (state, action) => {
                state.getAllLeadService.status = "success";
                state.getAllLeadService.leadService =
                    action.payload.data && action.payload.data;
                state.getAllLeadService.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getAllLeadServiceAsync.rejected, (state, action) => {
                state.getAllLeadService.status = "failed";
                state.getAllLeadService.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getLeadTemlateName.pending, (state) => {
                state.leadTemplateNameState.status = "loading";
            })
            .addCase(getLeadTemlateName.fulfilled, (state, action) => {
                state.leadTemplateNameState.status = "success";
                state.leadTemplateNameState.templateNames =
                    action.payload.data && action.payload.data;
                state.leadTemplateNameState.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getLeadTemlateName.rejected, (state, action) => {
                state.leadTemplateNameState.status = "failed";
                state.leadTemplateNameState.message =
                    action.payload.message && action.payload.message;
            });
    },
});

export default leadServiceSlice.reducer;
